export default "/assets/images/graph-pm.0c823047e78acaab.png";